module.exports = __webpack_public_path__ + "img/app-logo.63895aa5.png";